import { EmailRegistrationForm } from "../../organisms/form/EmailRegistrationForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { useEmailRegistration } from "./hook";

export const EmailRegistrationPage: React.FC = () => {
  const { handleEmailRegistration, handleResendEmail } = useEmailRegistration();

  return (
    <CardTemplate title="メール認証">
      <EmailRegistrationForm
        handleSubmit={handleEmailRegistration}
        handleResendEmail={handleResendEmail}
      />
    </CardTemplate>
  );
};

